import { render, staticRenderFns } from "./FormBuilderTemplateFields.vue?vue&type=template&id=92aee55e&"
import script from "./FormBuilderTemplateFields.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderTemplateFields.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderTemplateFields.vue?vue&type=style&index=0&id=92aee55e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports